import axios from 'axios';

export const getJobAlerts = async (jobseeker_id) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job-alerts`, {
            params: {
                job_seeker_id: jobseeker_id
            }
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}; 

export const createJobAlert = async (jobseeker_id, search_term) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}job-alerts/create`, {
            search_term: search_term,
            job_seeker_id: jobseeker_id
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}; 

export const deleteJobAlert = async (alert_id, jobseeker_id) => {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}job-alerts/${alert_id}`, {
            data: {
                job_seeker_id: jobseeker_id
            }
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}; 